/* eslint-disable import/prefer-default-export */

export const GET_DRIVER_PROFILE = "GET_DRIVER_PROFILE";
export const GET_DRIVER_PROFILE_ERROR = "GET_DRIVER_PROFILE_ERROR";
export const CREATE_DRIVER_PROFILE_SUCCESS = "CREATE_DRIVER_PROFILE_SUCCESS";
export const CREATE_DRIVER_PROFILE_FAILED = "CREATE_DRIVER_PROFILE_FAILED";
export const CREATE_DRIVER_PROFILE_PENDING = "CREATE_DRIVER_PROFILE_PENDING";
export const EDIT_DRIVER_PROFILE_SUCCESS = "EDIT_DRIVER_PROFILE_SUCCESS";
export const EDIT_DRIVER_PROFILE_FAILED = "EDIT_DRIVER_PROFILE_FAILED";
export const EDIT_DRIVER_PROFILE_PENDING = "EDIT_DRIVER_PROFILE_PENDING";
